import { useFeatureIsOn } from '@growthbook/growthbook-react';

/**
 * Google sign-in / sign-up is rolling out behind a GrowthBook gate
 * ("google-sign-in"). On the auth pages the user is not signed in yet, so
 * the flag evaluates against the environment/app attributes only — flip it
 * on per environment (review/staging) before enabling it in production.
 */
const useGoogleAuthEnabled = (): boolean => useFeatureIsOn('google-sign-in');

export default useGoogleAuthEnabled;
